<template>
  <div class="container">
    <div class="topNav">
      <div class="askExpert" @click="askExpert" v-if="!isExpert">
        <div class="text">请教专家</div>
        <i class="el-icon-arrow-right"></i>
      </div>
      <div class="myQuestion" @click="myQuestion">
        <div class="text">我的问题</div>
        <div class="questionWrap">
          <div class="questionNumber">{{total}}</div>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <Category
      :showTitle="showTitle"
      :cateList="cateList"
      :detailList="detailList"
      :showLeft="false"
      @select="selectItem($event)"
    />
    <Pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="size"
      @pagination="handleChange"
    />
  </div>
</template>

<script>
import Category from "@/components/Expert/Category";
import Pagination from "@/components/common/Pagination";
import { mapState } from "vuex";
import { getServerData } from "../utils/fetchData";
import { APIMAP } from "../constants/apiConstants";

export default {
  components: {
    Category,
    Pagination,
  },
  data() {
    return {
      showTitle: true,
      cateList: [],
      detailList: [],
      total: 0,
      page: 1,
      size: 10,
    };
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapState(["userInfo"]),
    isExpert() {
      if (this.userInfo.rolename === "pm2.5专家组") return true;
      return false;
    },
  },
  methods: {
    askExpert() {
      this.$router.push({
        path: "/askExpert",
      });
    },
    myQuestion() {
      this.$router.push({
        path: "/myProblem",
      });
    },
    // 获取具体问题
    async getData() {
      try {
        let params = {};
        params.page = this.page;
        params.size = this.size;
        params.pid = this.userInfo.platformid;
        if (this.userInfo.rolename === "pm2.5专家组") {
          params = {
            ...params,
            expertid: this.userInfo.gid,
          };
        } else {
          params = {
            ...params,
            uid: this.userInfo.gid,
          };
        }
        console.log("请求参数", params);
        const res = await getServerData(APIMAP.EXPERTASK, params);
        console.log("获取数据", res);
        res.rows.forEach((item) => {
          item.name = item.title;
        });
        this.detailList = res.rows;
        this.total = res.total;
      } catch (error) {
        console.log(error);
      }
    },
    selectItem(e) {
      // console.log(e);
      this.$router.push({
        path: `/problemDetails?gid=${e}`,
      });
    },
    handleChange() {
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  padding: 24px 27px;
  background: #f5f6fd;
  width: 100%;

  .topNav {
    display: flex;
    justify-content: space-between;
  }
  .askExpert,
  .myQuestion {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    background: #fff;
    flex: 1;
    height: 82px;
    line-height: 82px;
    font-size: 18px;
    color: #2c3a50;
    box-sizing: border-box;
    padding: 0 26px;
    border-radius: 2px;
    i {
      line-height: 82px;
    }
  }
  .askExpert {
    margin-right: 20px;
    .text {
      background: url("../assets/img/expert/experts.png") no-repeat;
      background-size: 28px 28px;
      background-position: 0px 26px;
      padding-left: 34px;
    }
  }

  .myQuestion {
    .text {
      background: url("../assets/img/expert/myquestion.png") no-repeat;
      background-size: 28px 28px;
      background-position: 0px 26px;
      padding-left: 34px;
    }
    .questionNumber {
      width: 18px;
      height: 18px;
      background: RGBA(255, 180, 49, 1);
      border-radius: 50%;
      text-align: center;
      line-height: 18px;
      color: #fff;
      margin: 31px 6px;
      font-size: 14px;
    }
    .questionWrap {
      // position: relative;
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>